export enum FeatureFlagVariables {
  aiDocumentValidationEnabledStructures = "ai_document_validation_enabled_structures",
  aiDocumentValidationEnabledServices = "ai_document_validation_enabled_services",
  aiDocValidationNaspiAbTest = "ai_doc_validation_naspi_ab_test",
  aiDocValidationNaspiAbTestStartDate = "ai_doc_validation_naspi_ab_test_start_date",
  householdMemberTaxCodeVariant = "household_member_tax_code_variant",
  confermaRequisitiExperimentVariant = "conferma_requisiti_experiment_variant",
  introScreen730ExperimentVariant = "intro_screen_730_experiment_variant",
  onboardingIntroExperimentVariant = "onboarding_intro_experiment_variant",
  readyToSendModalExperimentVariant = "ready_to_send_modal_experiment_variant",
}
